import { Element } from "@xmpp/xml"
import PubSubEventParser from "./PubSubEventParser"
import { DriverLocation } from "@/reducers/locationsSlice"
import LocationParser from "@/lib/locationParser"

class Parser {
  static readonly NAMESPACE = "http://jabber.org/protocol/geoloc"

  static parse(stanza: Element): DriverLocation | undefined {
    const geoloc = stanza?.getChild("geoloc", this.NAMESPACE)

    if (!geoloc) return

    const location = LocationParser.parseGeoloc(geoloc)

    return {
      jid: stanza.getAttr("id"),
      location,
    }
  }
}

export const LocationPubSubParser = new PubSubEventParser<DriverLocation>(
  Parser.parse,
  Parser.NAMESPACE,
)
